import store from '../store/store';
import { resetLocalOverrides } from '../utils/localOverrides';

export default function resetApplicationSettingOverridesAction() {
    resetLocalOverrides();
    store.overrides = {};
}
